import Typography from "@mui/material/Typography";

import CMSLogic from "@/src/logic/CMSLogic";
import { StrapiComponentType } from "@/src/type";

interface TextModuleProps {
  text?: StrapiComponentType.Element.Text;
  className?: string;
}

function TextModule({ text, className }: TextModuleProps) {
  if (!text || !text.text) {
    return <></>;
  }

  const breaks = (text?.text ?? "").split("\n");
  return (
    <Typography
      sx={{
        ...(text?.textAlign && { textAlign: `${text.textAlign} !important` }),
        ...(text?.fontSize && { fontSize: `${text.fontSize} !important` }),
        ...(text?.fontWeight && { fontWeight: `${CMSLogic.fontWeightSelector(text.fontWeight)} !important` }),
        ...(text?.color && { color: `${CMSLogic.colorSelector(text.color)} !important` }),
        ...(text?.lineHeight && { lineHeight: `${text.lineHeight} !important` }),
        ...(text?.letterSpacing && { letterSpacing: `${text.letterSpacing} !important` }),
        ...(text?.fontFamily && { fontFamily: `${CMSLogic.getFont(text?.fontFamily)} !important` }),
      }}
      variant={text?.tag}
      className={className}
    >
      {breaks.map((text, i) => (
        <span key={i}>
          {text}
          <br />
        </span>
      ))}
    </Typography>
  );
}

export default TextModule;
